import L from 'leaflet';
import store from '../store';
import {level14CentersAdded} from "../store/mapSlice";

export const S2MarkerType = {
	GYM: 1,
	STOP: 2,
	PORTAL: 3,
	PENDING: 4,
};

const S2 = {};

window.s2Polygons = {14: {}, 17: {}};

export const minZoomForLevel17 = 16;
let pendingLevel14Centers = [];

export const setupS2 = (onBoundsChanged, onCreatePolygon) => {
	const map = window.map;

	// Object.values(state.marker.gyms).forEach(gym => s2Portals[gym['s2-17']] = true);
	// Object.values(state.marker.stops).forEach(stop => s2Portals[stop['s2-17']] = true);

	(function () {
		function geodesicPoly(Klass, fill) {
			return Klass.extend({
				initialize: function (latlngs, options) {
					Klass.prototype.initialize.call(this, L.geodesicConvertLines(latlngs, fill), options);
					this._latlngsinit = this._convertLatLngs(latlngs);
				},
				getLatLngs: function () {
					return this._latlngsinit;
				},
				setLatLngs: function (latlngs) {
					this._latlngsinit = this._convertLatLngs(latlngs);
					return this.redraw();
				},
				addLatLng: function (latlng) {
					this._latlngsinit.push(L.latLng(latlng));
					return this.redraw();
				},
				spliceLatLngs: function () { // (Number index, Number howMany)
					var removed = [].splice.apply(this._latlngsinit, arguments);
					this._convertLatLngs(this._latlngsinit);
					this.redraw();
					return removed;
				},
				redraw: function() {
					this._latlngs = this._convertLatLngs(L.geodesicConvertLines(this._latlngsinit, fill));
					return Klass.prototype.redraw.call(this);
				}
			});
		}

		function geodesicConvertLine(startLatLng, endLatLng, convertedPoints) {
			var R = 6367000.0; // earth radius in meters (doesn't have to be exact)
			var d2r = Math.PI/180.0;
			var r2d = 180.0/Math.PI;

			// maths based on http://williams.best.vwh.net/avform.htm#Int

			var lat1 = startLatLng.lat * d2r;
			var lat2 = endLatLng.lat * d2r;
			var lng1 = startLatLng.lng * d2r;
			var lng2 = endLatLng.lng * d2r;

			var dLng = lng2-lng1;

			var segments = Math.floor(Math.abs(dLng * R / 5000));

			if (segments > 1) {
				// pre-calculate some constant values for the loop
				var sinLat1 = Math.sin(lat1);
				var sinLat2 = Math.sin(lat2);
				var cosLat1 = Math.cos(lat1);
				var cosLat2 = Math.cos(lat2);

				var sinLat1CosLat2 = sinLat1*cosLat2;
				var sinLat2CosLat1 = sinLat2*cosLat1;

				var cosLat1CosLat2SinDLng = cosLat1*cosLat2*Math.sin(dLng);

				for (var i=1; i < segments; i++) {
					var iLng = lng1+dLng*(i/segments);
					var iLat = Math.atan( (sinLat1CosLat2*Math.sin(lng2-iLng) + sinLat2CosLat1*Math.sin(iLng-lng1))
						/ cosLat1CosLat2SinDLng)

					var point = L.latLng ( [iLat*r2d, iLng*r2d] );
					convertedPoints.push(point);
				}
			}

			convertedPoints.push(L.latLng(endLatLng));
		}

		L.geodesicConvertLines = function (latlngs, fill) {
			if (latlngs.length === 0) {
				return [];
			}

			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (L.Util.isArray(latlngs[i]) && typeof latlngs[i][0] !== 'number') {
					return;
				}
				latlngs[i] = L.latLng(latlngs[i]);
			}

			// geodesic calculations have issues when crossing the anti-meridian. so offset the points
			// so this isn't an issue, then add back the offset afterwards
			// a center longitude would be ideal - but the start point longitude will be 'good enough'
			var lngOffset = latlngs[0].lng;

			// points are wrapped after being offset relative to the first point coordinate, so they're
			// within +-180 degrees
			latlngs = latlngs.map(function(a){ return L.latLng(a.lat, a.lng-lngOffset).wrap(); });

			var geodesiclatlngs = [];

			if(!fill) {
				geodesiclatlngs.push(latlngs[0]);
			}
			for (i = 0, len = latlngs.length - 1; i < len; i++) {
				geodesicConvertLine(latlngs[i], latlngs[i+1], geodesiclatlngs);
			}
			if(fill) {
				geodesicConvertLine(latlngs[len], latlngs[0], geodesiclatlngs);
			}

			// now add back the offset subtracted above. no wrapping here - the drawing code handles
			// things better when there's no sudden jumps in coordinates. yes, lines will extend
			// beyond +-180 degrees - but they won't be 'broken'
			geodesiclatlngs = geodesiclatlngs.map(function(a){ return L.latLng(a.lat, a.lng+lngOffset); });

			return geodesiclatlngs;
		}

		L.GeodesicPolyline = geodesicPoly(L.Polyline, 0);
		L.GeodesicPolygon = geodesicPoly(L.Polygon, 1);

		//L.GeodesicMultiPolyline = createMulti(L.GeodesicPolyline);
		//L.GeodesicMultiPolygon = createMulti(L.GeodesicPolygon);

		/*L.GeodesicMultiPolyline = L.MultiPolyline.extend({
		  initialize: function (latlngs, options) {
			L.MultiPolyline.prototype.initialize.call(this, L.geodesicConvertLines(latlngs), options);
		  }
		});*/

		/*L.GeodesicMultiPolygon = L.MultiPolygon.extend({
		  initialize: function (latlngs, options) {
			L.MultiPolygon.prototype.initialize.call(this, L.geodesicConvertLines(latlngs), options);
		  }
		});*/


		L.GeodesicCircle = L.Polygon.extend({
			initialize: function (latlng, radius, options) {
				this._latlng = L.latLng(latlng);
				this._mRadius = radius;

				const points = this._calcPoints();

				L.Polygon.prototype.initialize.call(this, points, options);
			},

			options: {
				fill: true
			},

			setLatLng: function (latlng) {
				this._latlng = L.latLng(latlng);
				const points = this._calcPoints();
				this.setLatLngs(points);
			},

			setRadius: function (radius) {
				this._mRadius = radius;
				const points = this._calcPoints();
				this.setLatLngs(points);

			},

			getLatLng: function () {
				return this._latlng;
			},

			getRadius: function() {
				return this._mRadius;
			},


			_calcPoints: function() {
				var R = 6367000.0; //earth radius in meters (approx - taken from leaflet source code)
				var d2r = Math.PI/180.0;
				var r2d = 180.0/Math.PI;

				// circle radius as an angle from the centre of the earth
				var radRadius = this._mRadius / R;


				// pre-calculate various values used for every point on the circle
				var centreLat = this._latlng.lat * d2r;
				var centreLng = this._latlng.lng * d2r;

				var cosCentreLat = Math.cos(centreLat);
				var sinCentreLat = Math.sin(centreLat);

				var cosRadRadius = Math.cos(radRadius);
				var sinRadRadius = Math.sin(radRadius);

				var calcLatLngAtAngle = function(angle) {
					var lat = Math.asin(sinCentreLat*cosRadRadius + cosCentreLat*sinRadRadius*Math.cos(angle));
					var lng = centreLng + Math.atan2(Math.sin(angle)*sinRadRadius*cosCentreLat, cosRadRadius-sinCentreLat*Math.sin(lat));

					return L.latLng(lat * r2d,lng * r2d);
				};

				var segments = Math.max(48,Math.floor(this._mRadius/1000));
				var points = [];
				for (var i=0; i<segments; i++) {
					var angle = Math.PI*2/segments*i;

					var point = calcLatLngAtAngle(angle)
					points.push ( point );
				}

				return points;
			},

		});


		L.geodesicPolyline = function (latlngs, options) {
			return new L.GeodesicPolyline(latlngs, options);
		};

		L.geodesicPolygon = function (latlngs, options) {
			return new L.GeodesicPolygon(latlngs, options);
		};

		/*
		L.geodesicMultiPolyline = function (latlngs, options) {
		  return new L.GeodesicMultiPolyline(latlngs, options);
		};

		L.geodesicMultiPolygon = function (latlngs, options) {
		  return new L.GeodesicMultiPolygon(latlngs, options);
		};

		*/

		L.geodesicCircle = function (latlng, radius, options) {
			return new L.GeodesicCircle(latlng, radius, options);
		}

	}());

	const setup  = () => {
		(function() {
			var LatLngToXYZ = function(latLng) {

				var d2r = Math.PI/180.0;

				var phi = latLng.lat*d2r;
				var theta = latLng.lng*d2r;

				var cosphi = Math.cos(phi);
				// console.log("joshw LatLngToXYZ: ", latLng.lat, latLng.lng, phi, theta);

				return [Math.cos(theta)*cosphi, Math.sin(theta)*cosphi, Math.sin(phi)];
			};

			var XYZToLatLng = function(xyz) {
				var r2d = 180.0/Math.PI;

				var lat = Math.atan2(xyz[2], Math.sqrt(xyz[0]*xyz[0]+xyz[1]*xyz[1]));
				var lng = Math.atan2(xyz[1], xyz[0]);

				return L.latLng(lat*r2d, lng*r2d);
			};

			var largestAbsComponent = function(xyz) {
				var temp = [Math.abs(xyz[0]), Math.abs(xyz[1]), Math.abs(xyz[2])];

				if (temp[0] > temp[1]) {
					if (temp[0] > temp[2]) {
						return 0;
					} else {
						return 2;
					}
				} else {
					if (temp[1] > temp[2]) {
						return 1;
					} else {
						return 2;
					}
				}

			};

			var faceXYZToUV = function(face,xyz) {
				var u,v;

				switch (face) {
					case 0: u =  xyz[1]/xyz[0]; v =  xyz[2]/xyz[0]; break;
					case 1: u = -xyz[0]/xyz[1]; v =  xyz[2]/xyz[1]; break;
					case 2: u = -xyz[0]/xyz[2]; v = -xyz[1]/xyz[2]; break;
					case 3: u =  xyz[2]/xyz[0]; v =  xyz[1]/xyz[0]; break;
					case 4: u =  xyz[2]/xyz[1]; v = -xyz[0]/xyz[1]; break;
					case 5: u = -xyz[1]/xyz[2]; v = -xyz[0]/xyz[2]; break;
					default: return;//throw {error: 'Invalid face'};
				}

				return [u,v];
			};




			var XYZToFaceUV = function(xyz) {
				var face = largestAbsComponent(xyz);

				if (xyz[face] < 0) {
					face += 3;
				}

				const uv = faceXYZToUV (face,xyz);

				return [face, uv];
			};

			var FaceUVToXYZ = function(face,uv) {
				var u = uv[0];
				var v = uv[1];

				switch (face) {
					case 0: return [ 1, u, v];
					case 1: return [-u, 1, v];
					case 2: return [-u,-v, 1];
					case 3: return [-1,-v,-u];
					case 4: return [ v,-1,-u];
					case 5: return [ v, u,-1];
					default: return;//throw {error: 'Invalid face'};
				}
			};


			var STToUV = function(st) {
				var singleSTtoUV = function(st) {
					if (st >= 0.5) {
						return (1/3.0) * (4*st*st - 1);
					} else {
						return (1/3.0) * (1 - (4*(1-st)*(1-st)));
					}
				}

				return [singleSTtoUV(st[0]), singleSTtoUV(st[1])];
			};



			var UVToST = function(uv) {
				var singleUVtoST = function(uv) {
					if (uv >= 0) {
						return 0.5 * Math.sqrt (1 + 3*uv);
					} else {
						return 1 - 0.5 * Math.sqrt (1 - 3*uv);
					}
				};

				return [singleUVtoST(uv[0]), singleUVtoST(uv[1])];
			};


			var STToIJ = function(st,order) {
				// console.log("joshw STToIJ: ", st, order)
				var maxSize = (1<<order);

				var singleSTtoIJ = function(st) {
					var ij = Math.floor(st * maxSize);
					return Math.max(0, Math.min(maxSize-1, ij));
				};

				return [singleSTtoIJ(st[0]), singleSTtoIJ(st[1])];
			};


			var IJToST = function(ij,order,offsets) {
				var maxSize = (1<<order);

				return [
					(ij[0]+offsets[0])/maxSize,
					(ij[1]+offsets[1])/maxSize
				];
			}

// hilbert space-filling curve
// based on http://blog.notdot.net/2009/11/Damn-Cool-Algorithms-Spatial-indexing-with-Quadtrees-and-Hilbert-Curves
// note: rather then calculating the final integer hilbert position, we just return the list of quads
// this ensures no precision issues whth large orders (S3 cell IDs use up to 30), and is more
// convenient for pulling out the individual bits as needed later
			var pointToHilbertQuadList = function(x,y,order) {
				var hilbertMap = {
					'a': [ [0,'d'], [1,'a'], [3,'b'], [2,'a'] ],
					'b': [ [2,'b'], [1,'b'], [3,'a'], [0,'c'] ],
					'c': [ [2,'c'], [3,'d'], [1,'c'], [0,'b'] ],
					'd': [ [0,'a'], [3,'c'], [1,'d'], [2,'d'] ]
				};

				var currentSquare='a';
				var positions = [];

				for (var i=order-1; i>=0; i--) {

					var mask = 1<<i;

					var quad_x = x&mask ? 1 : 0;
					var quad_y = y&mask ? 1 : 0;

					var t = hilbertMap[currentSquare][quad_x*2+quad_y];

					positions.push(t[0]);

					currentSquare = t[1];
				}

				return positions;
			};




// S2Cell class

			S2.S2Cell = function(){};

//static method to construct
			S2.S2Cell.FromLatLng = function(latLng,level) {
				var xyz = LatLngToXYZ(latLng);

				var faceuv = XYZToFaceUV(xyz);

				var st = UVToST(faceuv[1]);

				var ij = STToIJ(st,level);

				return S2.S2Cell.FromFaceIJ (faceuv[0], ij, level);
			};

			S2.S2Cell.FromFaceIJ = function(face,ij,level) {
				var cell = new S2.S2Cell();
				cell.face = face;
				cell.ij = ij;
				cell.level = level;

				return cell;
			};


			S2.S2Cell.prototype.toString = function() {
				return 'F'+this.face+'ij['+this.ij[0]+','+this.ij[1]+']@'+this.level;
			};

			S2.S2Cell.prototype.getLatLng = function() {
				var st = IJToST(this.ij,this.level, [0.5,0.5]);
				var uv = STToUV(st);
				var xyz = FaceUVToXYZ(this.face, uv);

				return XYZToLatLng(xyz);
			};

			S2.S2Cell.prototype.getCornerLatLngs = function() {
				var result = [];
				var offsets = [
					[ 0.0, 0.0 ],
					[ 0.0, 1.0 ],
					[ 1.0, 1.0 ],
					[ 1.0, 0.0 ]
				];

				for (var i=0; i<4; i++) {
					var st = IJToST(this.ij, this.level, offsets[i]);
					var uv = STToUV(st);
					var xyz = FaceUVToXYZ(this.face, uv);

					result.push ( XYZToLatLng(xyz) );
				}
				return result;
			};

			S2.S2Cell.prototype.getFaceAndQuads = function() {
				var quads = pointToHilbertQuadList(this.ij[0], this.ij[1], this.level);

				return [this.face,quads];
			};

			S2.S2Cell.prototype.getNeighbors = function() {

				var fromFaceIJWrap = function(face,ij,level) {
					var maxSize = (1<<level);
					if (ij[0]>=0 && ij[1]>=0 && ij[0]<maxSize && ij[1]<maxSize) {
						// no wrapping out of bounds
						return S2.S2Cell.FromFaceIJ(face,ij,level);
					} else {
						// the new i,j are out of range.
						// with the assumption that they're only a little past the borders we can just take the points as
						// just beyond the cube face, project to XYZ, then re-create FaceUV from the XYZ vector

						var st = IJToST(ij,level,[0.5,0.5]);
						var uv = STToUV(st);
						var xyz = FaceUVToXYZ(face,uv);
						var faceuv = XYZToFaceUV(xyz);
						face = faceuv[0];
						uv = faceuv[1];
						st = UVToST(uv);
						ij = STToIJ(st,level);
						return S2.S2Cell.FromFaceIJ (face, ij, level);
					}
				};

				var face = this.face;
				var i = this.ij[0];
				var j = this.ij[1];
				var level = this.level;


				return [
					fromFaceIJWrap(face, [i-1,j], level),
					fromFaceIJWrap(face, [i,j-1], level),
					fromFaceIJWrap(face, [i+1,j], level),
					fromFaceIJWrap(face, [i,j+1], level)
				];
			};


		})();
		// update();
	};

	const joshwConvertBounds = gBounds => {
		const northEast = gBounds.getNorthEast();
		const southWest = gBounds.getSouthWest();
		const latSpread = Math.abs(northEast.lat()-southWest.lat()) / 5; // joshw: load a lil extra
		const lngSpread = Math.abs(northEast.lng()-southWest.lng()) / 5;
		return L.latLngBounds(
			L.latLng(northEast.lat()+latSpread, northEast.lng()+lngSpread),
			L.latLng(southWest.lat()-latSpread, southWest.lng()-lngSpread)
		);
	};

	// Checks current map bounds, draws cells that don't exist
	const update = function() {
		const gBounds = map.getBounds();
		if( !gBounds )
			return; // ugh

		var bounds = joshwConvertBounds(gBounds);

		var seenCells = {};

		var drawCellAndNeighbors = function(cell) {
			// if( cell.level === 14 )
			// 	console.log("joshw dCAN: ");
			var cellStr = cell.toString();

			if (!seenCells[cellStr]) {
				// cell not visited - flag it as visited now
				seenCells[cellStr] = true;

				// is it on the screen?
				var corners = cell.getCornerLatLngs();
				var cellBounds = L.latLngBounds([corners[0],corners[1]]).extend(corners[2]).extend(corners[3]);

				if (cellBounds.intersects(bounds)) {
					// on screen - draw it
					drawCell(cell);

					// and recurse to our neighbors
					var neighbors = cell.getNeighbors();
					// console.log("Neighbors: ", neighbors);
					for (var i=0; i<neighbors.length; i++) {
						drawCellAndNeighbors(neighbors[i]);
					}
				}
			}
		};

		// centre cell
		var zoom = map.getZoom();
		if (zoom >= 5) {
			// var cellSize = zoom>=7 ? 17 : 17; // joshw todo
			const center = map.getCenter();
			try {
				let cell = S2.S2Cell.FromLatLng(L.latLng(center.lat(), center.lng()), 14);
				drawCellAndNeighbors(cell);
				if( zoom >= minZoomForLevel17 ) {
					cell = S2.S2Cell.FromLatLng(L.latLng(center.lat(), center.lng()), 17);
					drawCellAndNeighbors(cell);
				}
			} catch(error) {
				console.log("ERR drawing cells: " + error);
				return;
			}
		}

		if( pendingLevel14Centers.length ) {
			store.dispatch(level14CentersAdded(pendingLevel14Centers));
			pendingLevel14Centers = [];
		}

	};

	// joshw: here's the nut meat
	const drawCell = (cell) => {
		const latLng = cell.getLatLng();
		const key = latLng.lat.toFixed(4) + "," + latLng.lng.toFixed(4);

		if( window.s2Polygons[cell.level][key] )
			return;

		const corners = cell.getCornerLatLngs();
		corners.push(corners[0]);
		let opts = {
			path: corners,
			geodesic: true,
			strokeColor: cell.level === 17 ? "#000000" : "#006600",
			strokeOpacity: 0.3,
			strokeWeight: cell.level === 17 ? 1 : 4,
			fillOpacity: 0,
			clickable: cell.level === 17
		};

		let polygon = new window.maps.Polygon(opts);

		// TODO: a central marker to count the number of stops in this cell
		if( cell.level === 14 )
			pendingLevel14Centers.push({key, obj: {lat: latLng.lat, lng: latLng.lng}});

		if( cell.level === 17 )
			onCreatePolygon(polygon, key);

		polygon.setMap(window.map);


		window.s2Polygons[cell.level][key] = polygon;
	};

	setup();

	return update; // onBoundsChanged
}; // wrapper end